import { combineReducers } from 'redux'
import { routerReducer, RouterState } from 'react-router-redux'
import { jobDetailsReducer, publishedJobParamsReducer, JobDetailsState } from './setJobDetails'
import { SignInState, signInReducer } from './signIn'
import { jobReducer, JobPrototypeState } from './job'
import { DrawerState, drawerReduer } from './drawer'
import * as Types from '../types'
import { CompletedJobState, completedJobReducer } from './setCompletedJob'
import { UserState, userReducer } from './user'
import { ServiceInfoState, serviceInfoReducer } from './serviceInfo'
import {ChatState, chatReducer} from './chat'
import { CLEAN_ALL } from '../actions/store'
import { ErrorInfoState, errorInfoReducer } from './ErrorInfo'

export interface StoreState {
    auth: SignInState
    routing: RouterState
    currentJob: JobPrototypeState
    drawer: DrawerState
    jobDetails: JobDetailsState
    publishedJobParams: Types.PublishedJobParams
    completedJob: CompletedJobState
	user: UserState,
    serviceInfo: ServiceInfoState,
    errorInfo: ErrorInfoState,
    chat: ChatState
}

export const innerReducers = combineReducers<StoreState>({
    auth: signInReducer,
    routing: routerReducer,
    currentJob: jobReducer,
    jobDetails: jobDetailsReducer,
    drawer: drawerReduer,
    publishedJobParams: publishedJobParamsReducer,
    completedJob: completedJobReducer,
	user: userReducer,
    serviceInfo: serviceInfoReducer,
    errorInfo: errorInfoReducer,
    chat: chatReducer
})

export const reducers = (state, action) => {
    if (action.type === CLEAN_ALL) {
        state = {
            routing: state.routing
        }
    }

    return innerReducers(state, action)
}



// WEBPACK FOOTER //
// ./src/reducers/index.ts